import ProductsMegaMenu from 'organisms/MegaMenu/ProductsMegaMenu/ProductsMegaMenu';
import ProductsMegaMenuSideBar from 'organisms/MegaMenu/ProductsMegaMenu/ProductsMegaMenuSideBar';
import MightyProMegaMenu from 'organisms/MegaMenu/MightyProMegaMenu/MightyProMegaMenu';
import ResourcesMegaMenu from 'organisms/MegaMenu/ResourcesMegaMenu/ResourcesMegaMenu';
import ResourcesMegaMenuSideBar from 'organisms/MegaMenu/ResourcesMegaMenu/ResourcesMegaMenuSideBar';
import MightyProMegaMenuSideBar from 'organisms/MegaMenu/MightyProMegaMenu/MightyProMegaMenuSideBar';

export interface ExpandableMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface IMenuLink {
  text: string;
  href?: string;
  trackingSlug?: string;
  // Optional Mega Menu options
  useExpandableMenu?: boolean;
  expandableMenu?: (props: ExpandableMenuProps) => JSX.Element;
}

export type HeaderLinkSet = 'standard' | 'pro';
type HeaderLinkSubSet = 'top_menu' | 'side_menu';

// Desktop TopBar Links
// TODO (MKT-9341): MegaMenu content is pending
const MENU_LINKS: IMenuLink[] = [
  {
    text: 'Product',
    trackingSlug: 'all_features',
    useExpandableMenu: true,
    expandableMenu: ProductsMegaMenu,
  },
  {
    text: 'Resources',
    trackingSlug: 'resources',
    useExpandableMenu: true,
    expandableMenu: ResourcesMegaMenu,
  },
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
  {
    text: 'Branded Apps',
    trackingSlug: 'mighty_pro',
    useExpandableMenu: true,
    expandableMenu: MightyProMegaMenu,
  },
];

// Mobile SideMenu Links
const SIDE_BAR_LINKS = [
  {
    text: 'Product',
    trackingSlug: 'all_features',
    useExpandableMenu: true,
    expandableMenu: ProductsMegaMenuSideBar,
  },
  {
    text: 'Resources',
    trackingSlug: 'resources',
    useExpandableMenu: true,
    expandableMenu: ResourcesMegaMenuSideBar,
  },
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
  {
    text: 'Branded Apps',
    trackingSlug: 'mighty_pro',
    useExpandableMenu: true,
    expandableMenu: MightyProMegaMenuSideBar,
  },
];

export const createHeaderLinks = (subset: HeaderLinkSubSet): IMenuLink[] => {
  switch (subset) {
    case 'top_menu':
      return MENU_LINKS;
    case 'side_menu':
      return SIDE_BAR_LINKS;
    default:
      return [];
  }
};
